"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _ChevronLeft = _interopRequireDefault(require("../Icons/ChevronLeft"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Breadcrumb(props) {
  var activeRoute = props.activeRoute,
    _props$back = props.back,
    back = _props$back === void 0 ? true : _props$back,
    onBack = props.onBack;
  var history = (0, _reactRouterDom.useHistory)();
  var handleBack = (0, _react.useCallback)(function (evt) {
    if (onBack) onBack(evt);else history.goBack();
  }, [history.goBack, onBack]);
  if (!activeRoute) return null;
  var general = activeRoute.general,
    specific = activeRoute.specific;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, back && /*#__PURE__*/_react["default"].createElement("span", {
    className: _stylesModule["default"].leftBack,
    onClick: handleBack
  }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], {
    width: "2.20rem",
    height: "2.20rem"
  })), general && /*#__PURE__*/_react["default"].createElement("span", {
    className: _stylesModule["default"].title
  }, " ", general.label, " "), specific && specific.label && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "|", /*#__PURE__*/_react["default"].createElement("span", {
    className: _stylesModule["default"].subTitle
  }, " ", specific.label, " "), ' '));
}
Breadcrumb.propTypes = {
  activeRoute: _propTypes["default"].shape({
    general: _propTypes["default"].shape({
      label: _propTypes["default"].string
    }),
    specific: _propTypes["default"].shape({
      label: _propTypes["default"].string
    })
  })
};
Breadcrumb.defaultProps = {
  activeRoute: {
    general: null,
    specific: null
  }
};
var _default = exports["default"] = Breadcrumb;